export const artwork = {
  original: `${import.meta.env.BASE_URL}landing/stencils/peony-reference.webp`,
  outline: `${import.meta.env.BASE_URL}landing/stencils/peony-outline.webp`,
  standard: `${import.meta.env.BASE_URL}landing/stencils/peony-standard.webp`,
  hatching: `${import.meta.env.BASE_URL}landing/stencils/peony-hatching.webp`,
};

export const artworkReelExamples = [
  {
    id: "joker-hatching",
    style: "hatching",
    label: "Hatching",
    original: `${import.meta.env.BASE_URL}landing/stencils/joker-reference.webp`,
    stencil: `${import.meta.env.BASE_URL}landing/stencils/joker-hatching.webp`,
  },
  {
    id: "geometric-stencil",
    style: "hatching",
    label: "Hatching",
    original: `${import.meta.env.BASE_URL}landing/stencils/geometric-reference.webp`,
    stencil: `${import.meta.env.BASE_URL}landing/stencils/geometric-stencil.webp`,
  },
  {
    id: "tupac-stencil",
    style: "hatching",
    label: "Hatching",
    original: `${import.meta.env.BASE_URL}landing/stencils/tupac-reference.webp`,
    stencil: `${import.meta.env.BASE_URL}landing/stencils/tupac-stencil.webp`,
  },
  {
    id: "backpiece-stencil",
    style: "hatching",
    label: "Hatching",
    original: `${import.meta.env.BASE_URL}landing/stencils/backpiece-reference.webp`,
    stencil: `${import.meta.env.BASE_URL}landing/stencils/backpiece-stencil.webp`,
  },
  {
    id: "mandala-stencil",
    style: "hatching",
    label: "Hatching",
    original: `${import.meta.env.BASE_URL}landing/stencils/mandala-reference.webp`,
    stencil: `${import.meta.env.BASE_URL}landing/stencils/mandala-stencil.webp`,
  },
] as const;
